<script>
  import {faExclamationTriangle, faTrashAlt, faPlus, faArrowUp, faArrowDown} from '@fortawesome/free-solid-svg-icons'

  export default {
    data () {
      return {
        iconError: faExclamationTriangle,
        iconDelete: faTrashAlt,
        iconAdd: faPlus,
        iconUp: faArrowUp,
        iconDown: faArrowDown,
      }
    },
    computed: {
      translations () {
        return this.translationRoot ? this.translationRoot : this.store.split('/')[0]
      },
      childSlots () {
        return this.$store.getters[this.store + '/childSlots'].map((store) => this.store + '/' + store)
      }
    },
    beforeDestroy () {
      this.reset()
    },
    methods: {
      reset () {
        this.$store.dispatch(this.store + '/reset')
      },
      item (child) {
        return this.$store.getters[`${this.store}/${child}/item`]
      },
      error (child) {
        return this.$store.getters[`${this.store}/${child}/error`]
      },
      addChild () {
        this.$store.dispatch(this.store + '/addChild').then((childName => {
          this.$emit('add-child', childName)
        }))
      },
      removeChild (childName) {
        this.$store.dispatch(this.store + '/removeChild', childName).then(() => {
          this.$emit('remove-child', childName)
        })
      },
      moveChild (childName, position) {
        this.$store.dispatch(this.store + '/moveChild', {childName, position}).then(() => {
          this.$emit('moved-child', childName)
        })
      },
    },
    props: {
      store: {
        type: String,
        required: true
      },
      translationRoot: {
        type: String
      },
      disabled: Boolean
    }
  }
</script>
<template>
  <div>
    <b-row class="inner">
    <slot
      name="header"
      v-bind:className="'col-11'"
      v-bind:translationRoot="translations"
    >
    </slot>
      <b-col cols="1">
        <b-button @click="addChild"><font-awesome-icon :icon="iconAdd"></font-awesome-icon></b-button>
      </b-col>
    </b-row>

    <b-form-group
      v-for="childStore, index in childSlots"
      :key="childStore"
      :disabled="disabled"
    >
      <b-row>
        <b-alert v-if="error(childStore)" show variant="danger" class="col-12"><font-awesome-icon :icon="iconError"></font-awesome-icon> {{ error(childStore) }}</b-alert>
      </b-row>
      <b-row class="inner">
        <slot
          v-bind:store="childStore"
          v-bind:translationRoot="translations"
          v-bind:className="'col-11'"
          v-bind:item="item(childStore)"
        ></slot>
        <b-col cols="1">
          <b-button @click="removeChild(childStore)"><font-awesome-icon :icon="iconDelete"></font-awesome-icon></b-button>
          <b-button :disabled="index === 0" @click="moveChild(childStore, index - 1)"><font-awesome-icon :icon="iconUp"></font-awesome-icon></b-button>
          <b-button :disabled="index === childSlots.length - 1" @click="moveChild(childStore, index + 1)"><font-awesome-icon :icon="iconDown"></font-awesome-icon></b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>
